import { Button } from 'antd';
import { MailOpen } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useGetAllOfferLettersQuery } from '../../app/features/recruitment/recruitment.api';
import { useAppFilters } from '../../hooks';
import useAuth from '../../hooks/useAuth';
import { JobCardSkeleton } from './components/JobCardSkeleton';
import { OfferLetterCard } from './components/OfferLetterCard';
import { EmptyState, PortalPagination, PortalShell } from './components/portal';
import { PATHS } from '../../routes/paths';

const OfferLetter = () => {
  const navigate = useNavigate();
  const { verifiedInfo } = useAuth();
  const { limit, page, handlePagination } = useAppFilters(
    'offer-letter-filters',
  );

  const { data, isLoading, isFetching } = useGetAllOfferLettersQuery(
    {
      applicant_id: verifiedInfo?.id as string,
      page,
      limit,
    },
    { skip: !verifiedInfo?.id },
  );

  const offerLetters = data?.data?.data || [];
  const total = data?.data?.meta?.total || 0;

  return (
    <PortalShell
      tab="offers"
      title="Offer letters"
      description="Review the offers you've received and accept or decline them here."
    >
      {isLoading || isFetching ? (
        <div className="grid gap-4 md:grid-cols-2">
          {[...Array(2)].map((_, i) => (
            <JobCardSkeleton key={i} />
          ))}
        </div>
      ) : offerLetters.length > 0 ? (
        <div className="grid gap-4 md:grid-cols-2">
          {offerLetters.map((offer) => (
            <OfferLetterCard key={offer.offer_letter_id} offer={offer} />
          ))}
        </div>
      ) : (
        <EmptyState
          icon={MailOpen}
          title="No offer letters yet"
          description="Offers from companies you've applied to will show up here."
          action={
            <Button
              onClick={() => navigate(PATHS.jobPortal.applications)}
              className="h-9 rounded-full px-5 font-medium"
            >
              View applications
            </Button>
          }
        />
      )}

      <PortalPagination
        page={page}
        limit={limit}
        total={total}
        onChange={handlePagination}
      />
    </PortalShell>
  );
};

export default OfferLetter;
